module.exports = __webpack_public_path__ + "static/butcher-5b1ab756557e8ba9efb052f9e84e0f44.jpg";